import React from "react";
import { Navigate } from "react-router-dom";

// Route Views
import { HomePage } from './views/pages/home-page';
import ThinkingTalentsPage from './views/pages/thinking-talents-page';
import MindPatternPage from './views/pages/mind-pattern-page';
import QuestionnairesPage from './views/pages/questionnaires-page';

import { TeamsAdminPage, TeamsEditPage, TeamsAddMemberPage, TeamDetailPage } from './views/pages/teams';
import NotFoundPage from './views/pages/not-found-page';
import LoginPage from './views/pages/auth/login-page';
import RegisterPage from "./views/pages/auth/register/register-page";
import confirmRegister from "./views/pages/auth/register/confirm-register";
import { HomeAuthPage } from "./views/pages/auth/homeAuth-page";
import MyProfile from "./views/pages/myProfile/MyProfile";
import ForgotPassword from "./views/pages/auth/forgotPassword/ForgotPassword";
import ResetPassword from "./views/pages/auth/forgotPassword/ResetPassword";
import ContactUs from "./views/pages/contactUs/ContactUs";
import PrivacyPage from "./views/pages/privacy/PrivacyPage";
import { QuestionnairePage } from "./views/pages/home/questionnaires/QuestionnairePage";
import { ResetPasswordDone } from "./views/pages/auth/forgotPassword/ResetPasswordDone";
import { Community } from "./views/pages/community/Community";
import { MyDocuments } from "./views/pages/myDocuments/MyDocuments";
import { AccountInformationSent } from "./views/pages/accountInformation/AccountInformationSent";

const routes = [
  {
    name: "index",
    path: "/",
    exact: true,
    component: () => <Navigate to="/home" replace />
  },
  {
    name: 'home',
    path: "/home",
    component: HomePage
  },
  {
    name: 'welcome',
    path: "/welcome",
    component: HomeAuthPage
  },
  {
    name: 'questionnaires',
    path: '/questionnaires',
    component: QuestionnairesPage
  },
  {
    name: 'questionnaire',
    path: '/questionnaire/:id',
    component: QuestionnairePage
  },
  {
    name: 'login',
    path: "/login",
    component: LoginPage
  },
  {
    name: 'signup',
    path: "/signup",
    component: RegisterPage
  },
  {
    name: 'confirmRegister',
    path: "/confirm-register",
    component: confirmRegister
  },
  {
    name: 'forgotRegister',
    path: "/forgot-password",
    component: ForgotPassword
  },
  {
    name: 'resetPassword',
    path: "/reset-password",
    component: ResetPassword
  },
  {
    name: 'resetPasswordDone',
    path: "/reset-password-done",
    component: ResetPasswordDone
  },
  {
    name: 'thinkingTalents',
    path: "/thinking-talents",
    component: ThinkingTalentsPage
  },
  {
    name: 'mind_pattern',
    path: "/mind-patterns",
    component: MindPatternPage
  },
  {
    name: 'teams_edit',
    path: "/teams/:id/edit",
    component: TeamsEditPage
  },
  {
    name: 'teams_add_member',
    path: "/teams/:id/add-member",
    component: TeamsAddMemberPage
  },
  {
    name: 'teams_detail',
    path: "/teams/:id",
    component: TeamDetailPage
  },
  {
    name: 'teams',
    path: "/teams",
    component: TeamsAdminPage
  },
  {
    name: 'contactUs',
    path: "/contact-us",
    component: ContactUs
  },
  {
    name: 'profile',
    path: "/profile",
    component: MyProfile
  },
  {
    name: 'privacy',
    path: "/privacy",
    component: PrivacyPage
  },
  {
    name: 'community',
    path: "/community",
    component: Community
  },
  {
    name: 'my-documents',
    path: '/my-documents',
    component: MyDocuments
  },
  {
    name: 'account-information-sent',
    path: '/account-information-sent',
    component: AccountInformationSent
  },
  {
    name: 'not-found',
    path: "*",
    component: NotFoundPage
  },
];
export default routes